import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './Admin.css';
import AdminLinkTile from '../../components/admin/admin-link-tile';
import { getLoginUserDetails } from '../../api/adminuserapi';

import { useDispatch } from "react-redux";
import { showLoading, hideLoading, delayedHideLoading } from '../../store/loading-reducer';
import { useAdminMenuContext } from "../../context/AdminMenuContext";

function Admin() {
    const dispatch = useDispatch();
    const [loginUser, setLoginUser] = useState(null);
    const [editLink, setEditLink] = useAdminMenuContext('');
    const { userClaims } = useSelector((state) => state.auth);

    useEffect(() => {
        dispatch(showLoading());
    }, [dispatch]);

    useEffect(() => {
        document.title = 'Dashboard | CWP Employee Portal';
        dispatch(showLoading());
        getLoginUserDetails()
            .then((response) => {
                setLoginUser(response?.data);
                dispatch(delayedHideLoading());
            }).catch(() => {
                dispatch(hideLoading());
            });
        setEditLink('');
        console.log(editLink);
    }, []);

    console.log("loginUser", loginUser);

    const hasAccess = (key) => {
        if (!userClaims || userClaims.length === 0) return false;
        return userClaims.some(c => c.value?.toLowerCase().includes(key.toLowerCase()));
    };

    return (
        <div className="admin-page-wrap">

            <div className="admin-top-bar-wrap">
                &nbsp;
            </div>

            <div className="admin-page-content">  
                <div className="admin-link-tile-wrap">

                    {hasAccess('events') && (
                        <AdminLinkTile
                            href="/siteadmin/events"
                            icon="calendar_today"
                            name="Events"
                        />
                    )}

                    {hasAccess('happenings') && (
                        <AdminLinkTile
                            href="/siteadmin/news"
                            icon="newsmode"
                            name="Happenings"
                        />
                    )}

                    {hasAccess('hrbenefits') && (
                        <AdminLinkTile
                            href="/siteadmin/hrbenefits"
                            icon="verified"
                            name="HR & Benefits"
                        />
                    )}

                    {hasAccess('employees') && (
                        <AdminLinkTile
                            href="/siteadmin/employee"
                            icon="group"
                            name="Employees"
                        />
                    )}

                    {hasAccess('departments') && (
                        <AdminLinkTile
                            href="/siteadmin/departments"
                            icon="news"
                            name="Departments"
                        />
                    )}

                    {hasAccess('marketplace') && (
                        <AdminLinkTile
                            href="/siteadmin/marketplace"
                            icon="newsmode"
                            name="Market Place"
                        />
                    )}

                    {hasAccess('contest') && (
                        <AdminLinkTile
                            href="/siteadmin/contest"
                            icon="newsmode"
                            name="Contest"
                        />
                    )}

                    {hasAccess('positionsqualifications') && (
                        <AdminLinkTile
                            href="/siteadmin/skills"
                            icon="work"
                            name="Positions & Qualifications"
                        />
                    )}

                    {hasAccess('interests') && (
                        <AdminLinkTile
                            href="/siteadmin/interests"
                            icon="interests"
                            name="Interests"
                        />
                    )}

                    {hasAccess('installedprojects') && (
                        <AdminLinkTile
                            href="/siteadmin/projects"
                            icon="perm_media"
                            name="Installed Projects"
                        />
                    )}

                    {hasAccess('financials') && (
                        <AdminLinkTile
                            href="/siteadmin/financials"
                            icon="local_atm"
                            name="Financials"
                        />
                    )}

                    {hasAccess('textalerts') && (
                        <AdminLinkTile
                            href="/siteadmin/textalerts"
                            icon="notifications"
                            className="material-symbols-rounded-outline"
                            name="Text Alerts"
                        />
                    )}

                    {hasAccess('documentlibrary') && (
                        <AdminLinkTile
                            href="/siteadmin/document-library"
                            icon="folder"
                            name="Document Library"
                        />
                    )}

                    {hasAccess('ggobresources') && (
                        <AdminLinkTile
                            href="/siteadmin/ggob-resources"
                            icon="info"
                            name="GGOB Resources"
                        />
                    )}

                    {hasAccess('companyshopmonitors') && (
                        <AdminLinkTile
                            href="/siteadmin/company-shop-monitor-ips"
                            icon="apartment"
                            name="Company Shop Monitor IPs"
                        />
                    )}

                    {hasAccess('adminusers') && (
                        <AdminLinkTile
                            href="/siteadmin/admin-users"
                            icon="group"
                            name="Admin Users"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Admin;